<template>
  <div class="cert_field_container">
    <mt-cell
      title="证件类型"
      is-link
      :value="value | certFilter"
      @click.native="showCertPicker"/>

    <mt-popup v-model="popupVisible" :closeOnClickModal="false" position="bottom" class="cert_popup">
      <mt-picker :slots="slots" @change="changeCert" show-toolbar>
        <span class="mint-datetime-action mint-datetime-cancel" @click="cancel">取消</span>
        <span class="mint-datetime-action mint-datetime-confirm" @click="confirm">确定</span>
      </mt-picker>
    </mt-popup>
  </div>
</template>

<script>
import modalHelper from '@/utils/scroll'

export default {
  name: 'cert-field',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: ['value'],
  watch: {
    value () {
      this.slots[0].defaultIndex = this.value - 1
    }
  },
  data () {
    return {
      popupVisible: false,
      certType: '',
      slots: [
        {
          flex: 1,
          values: ['身份证', '护照'],
          defaultIndex: 0,
          className: 'slot1',
          textAlign: 'center'
        }
      ]
    }
  },
  filters: {
    certFilter(cert) {
      const certMap = { 1: '身份证', 2: '护照' }
      return certMap[cert]
    }
  },
  created () {
    this.slots[0].defaultIndex = this.value - 1
  },
  methods: {
    showCertPicker () {
      this.popupVisible = true
    },
    changeCert (picker, values) {
      let label = values[0]
      let value = label === '身份证' ? 1 : 2
      this.certType = value
    },
    confirm () {
      this.$emit('change', this.certType)
      modalHelper.beforeClose()
      this.popupVisible = false
    },
    cancel () {
      modalHelper.beforeClose()
      this.popupVisible = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  .cert_popup {
    width: 100%;
    .picker-toolbar {
      border-bottom: solid 1px #eaeaea;
    }
  }
</style>
